import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Profile } from 'app/_models/profile';
import { SalesPurchases, SalesPurchasesFilter } from 'app/_models/sales-purchases';
import { SalesPurchasesService } from 'app/_services/sales-purchases.service';
import { List } from 'app/shared/list';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.css'],
})
export class SalesListComponent extends List implements OnInit {
  profile: Profile;
  filter: SalesPurchasesFilter = new SalesPurchasesFilter();
  salesPurchaces: Array<any> = [];

  loading = false;

  constructor(private salesPurchasesService: SalesPurchasesService, private router: Router, private route: ActivatedRoute) {
    super(salesPurchasesService, new SalesPurchases(), router, route);
  }

  ngOnInit() {
    const params = SalesPurchasesFilter.serializeRouterParams(this.filter);
    const serialize_params = this.filter.serializeQueryParams(params);

    this.getSales(serialize_params);
  }

  getSales(serialize_params) {
    this.loading = true;
    this.salesPurchasesService.list(1, 10000, serialize_params, '').subscribe(
      (response) => {
        for (const item of response) {
          this.salesPurchaces.push(new SalesPurchases().apiMap(item));
        }
        this.loading = false;
      },
      (error) => {
        this.httpErrorHandler.handleHttpError(error);
        this.loading = false;
      }
    );
  }

  toggleExpandAuction(item) {
    item.expanded = !item.expanded;
    for (const sPItem of this.salesPurchaces) {
      if (sPItem.expanded && item.id !== sPItem.id) {
        sPItem.expanded = false;
      }
    }
  }

  applyFilter(params) {
    this.salesPurchaces = [];
    this.getSales(params);
  }
}



// WEBPACK FOOTER //
// ./src/app/sales/sales-list/sales-list.component.ts